<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_energy_costing"></Header>
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="false"
      @alertToggleUpdate="flashMessageTimeOut()"
    ></flash-message>

    <v-container fluid>

      <div class="timetable-container energy-table">
        <vue-excel-editor
          v-model="formattedTableData"
          free-select
          no-header-edit
          disable-panel-filter
          @update="onUpdateTable"
        >
          <vue-excel-column
            field="months"
            :label="'lng_consumption_2' | translate"
            type="string"
            readonly
            :sort="noSorting"
          />
          <vue-excel-column field="0" label="00.00-00.59" type="string" :sort="noSorting" />
          <vue-excel-column field="1" label="01.00-01.59" type="string" :sort="noSorting" />
          <vue-excel-column field="2" label="02.00-02.59" type="string" :sort="noSorting" />
          <vue-excel-column field="3" label="03.00-03.59" type="string" :sort="noSorting" />
          <vue-excel-column field="4" label="04.00-04.59" type="string" :sort="noSorting" />
          <vue-excel-column field="5" label="05.00-05.59" type="string" :sort="noSorting" />
          <vue-excel-column field="6" label="06.00-06.59" type="string" :sort="noSorting" />
          <vue-excel-column field="7" label="07.00-07.59" type="string" :sort="noSorting" />
          <vue-excel-column field="8" label="08.00-08.59" type="string" :sort="noSorting" />
          <vue-excel-column field="9" label="9.00-9.59" type="string" :sort="noSorting" />
          <vue-excel-column field="10" label="10.00-10.59" type="string" :sort="noSorting" />
          <vue-excel-column field="11" label="11.00-11.59" type="string" :sort="noSorting" />
          <vue-excel-column field="12" label="12.00-12.59" type="string" :sort="noSorting" />
          <vue-excel-column field="13" label="13.00-13.59" type="string" :sort="noSorting" />
          <vue-excel-column field="14" label="14.00-14.59" type="string" :sort="noSorting" />
          <vue-excel-column field="15" label="15.00-15.59" type="string" :sort="noSorting" />
          <vue-excel-column field="16" label="16.00-16.59" type="string" :sort="noSorting" />
          <vue-excel-column field="17" label="17.00-17.59" type="string" :sort="noSorting" />
          <vue-excel-column field="18" label="18.00-18.59" type="string" :sort="noSorting" />
          <vue-excel-column field="19" label="19.00-19.59" type="string" :sort="noSorting" />
          <vue-excel-column field="20" label="20.00-20.59" type="string" :sort="noSorting" />
          <vue-excel-column field="21" label="21.00-21.59" type="string" :sort="noSorting" />
          <vue-excel-column field="22" label="22.00-22.59" type="string" :sort="noSorting" />
          <vue-excel-column field="23" label="23.00-23.59" type="string" :sort="noSorting" />
        </vue-excel-editor>

        <div class="ma-4">
          <span>{{ "lng_costing_hint" | translate }}</span>
        </div>
        <div class="wrap-btn-timer my-4">
          <v-btn
            color="rgb(84,110,122)"
            class="white--text"
            @click="saveTimeTableData"
            >{{ "lng_save" | translate }}</v-btn
          >
        </div>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GlobalService from "../services/global-service";
import FlashMessage from "../components/FlashMessage";
import { translate } from "../common/HelperFunctions";
import { weeklyTimings } from "../common/TimeTableData";
import TimeTablePerHour from "../components/TimeTablePerHour";

export default {
  name: "CostingTable",
  components: {
    Header,
    FlashMessage,
    TimeTablePerHour,
  },
  data: () => ({
    userMenuData: undefined,
    alertToggle: false,
    flashMessageData: {},
    responseObj: {},
    pageRefreshTime: 30,
    timerKey: 0,
    weeklyTimingsData: weeklyTimings,
    costingData: undefined,
    formattedTableData: [],
    elCountries: [],
    selectedCountry: undefined,
    elProviders: [],
    selectedProvider: undefined,
    rules: {
      selectCountry: [(v) => !!v || translate('lng_required_country')],
      selectProvider: [(v) => !!v || translate("lng_required_provider")],
    }
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
  },
  methods: {
    noSorting(a, b){},
    async FetchApisData() {
      this.userMenuData = await GlobalService.getMenuData(
        "extheat",
        this.getUser.token
      );
      this.costingData = this.userMenuData["extheat.table"].val;
      await this.initTimingData();
      this.$store.commit("global/setLoading", false);
      this.getCountriesData();
    },
    async getCountriesData() {
      this.elCountries = await GlobalService.getelCountries();
    },
    async getProvidersData(country) {
      this.selectedCountry = country;
      let data = await GlobalService.getelProviders();
      this.elProviders = data.filter(e => e.countrycode === country);
    },
    async getPrefilledValues(){
      
      if(this.selectedCountry && this.selectedProvider){
        let data = await GlobalService.getelValues(this.selectedProvider);
        if(Object.keys(data).length){
          this.costingData = data;
          await this.initTimingData();
        }
      }

    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        saved: resObj.onlineandsaved ? "lng_save_ok" : "lng_save_notok",
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red",
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
      this.timerKey += 1;
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    },
    async initTimingData() {
      let completeMonthNames = [
        translate("lng_month_jan"),
        translate("lng_month_feb"),
        translate("lng_month_mar"),
        translate("lng_month_apr"),
        translate("lng_month_may"),
        translate("lng_month_jun"),
        translate("lng_month_jul"),
        translate("lng_month_aug"),
        translate("lng_month_sep"),
        translate("lng_month_oct"),
        translate("lng_month_nov"),
        translate("lng_month_dec"),
      ];
      let months = [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec",
      ];
      let hours = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ];
      let compileJsonData = [];
      months.forEach((mon, monIndex) => {
        let monthObject = {
          nameOfMon: mon,
          months: completeMonthNames[monIndex],
        };
        hours.forEach((hour, hourIndex) => {
          monthObject[`${hour}`] = Number(this.costingData[`${mon}.${hour}`]).toFixed(2);
        });
        compileJsonData.push(monthObject);
      });
      this.formattedTableData = compileJsonData;
    },
    async encode() {
      let costingObject = "{";
      this.formattedTableData.forEach((element) => {
        let monthName = element.nameOfMon;
        for (let index = 0; index < 24; index++) {
          costingObject += `"${monthName}.${index}":${Number(
            element[index]
          ).toFixed(2)},`;
        }
      });
      costingObject = costingObject.substring(0, costingObject.length - 1);
      costingObject += "}";
      return costingObject;
    },
    async saveTimeTableData() {
      let encodedData = await this.encode();
      let response;
      try {
        response = await GlobalService.saveFieldData(
          "extheat",
          "extheat.table",
          this.getUser.token,
          encodedData
        );
      } catch (e) {
        let resObj = { status: 1, message: "Try again later" };
        this.setResponseAlert(resObj);
      }
      this.setResponseAlert(response);
    },
    selectAllTimeTableData() {
      // this.weeklyTimingsData= weeklyTimings;
      this.weeklyTimingsData.days.forEach((day) => {
        day.hours.forEach((hour) => {
          hour.value = 0;
        });
      });
    },
    clearAllTimeTableData() {
      // this.weeklyTimingsData= weeklyTimings;
      this.weeklyTimingsData.days.forEach((day) => {
        day.hours.forEach((hour) => {
          hour.value = 1;
        });
      });
    },
    copyMondayTimeTableData() {
      for (let i = 1; i < this.weeklyTimingsData.days.length; i++) {
        for (
          let hour = 0;
          hour < this.weeklyTimingsData.days[i].hours.length;
          hour++
        ) {
          this.weeklyTimingsData.days[i].hours[hour].value =
            this.weeklyTimingsData.days[0].hours[hour].value;
        }
      }
    },
    onUpdateTable(records) {
      records.forEach((element, index) => {
        let tableInd = this.formattedTableData.findIndex(
          (e) => e.$id === element.$id
        );
        let convertedVal = element.newVal.replace(",", ".");
        if (tableInd !== -1)
          this.formattedTableData[tableInd][element.name] =
            Number(convertedVal).toFixed(2);
      });
    },
  },
};
</script>
<style scoped>
.wrap-btn-timer {
  justify-content: flex-start;
  display: flex;
  padding-left: 12px;
}
.energy-table td {
  min-width: 140px !important;
}
</style>
